import { apiClient } from "./api";

export const getContactUsData = async () => {
    try {
        const response = await apiClient.get("/contact-us");
        if (response.status === 200 || response.status === 201) {
            return { status: true, response: response.data };
        }
        return { status: false, response: response.data };
    } catch (error) {
        console.error("Error fetching contact us data:", error);
        return { status: false, response: error?.response?.data || error };
    }
};

export const deleteContactUsData = async (id) => {
    try {
        const response = await apiClient.delete(`/contact-us/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting contact us data:", error);
        throw error;
    }
};
